export default __webpack_public_path__ + "static/media/nomineeFamilyIcon.8470b0ac.svg";